import { makeCreateAction, makeCreateRoutine } from '../../helpers/actions';
import { VerificationStep } from '../interfaces';

const createAction = makeCreateAction('USER');
const createRoutine = makeCreateRoutine('USER');

function createVerifyRoutine(type: string) {
  return createRoutine(type, {
    request: (value) => ({ value }),
    fulfill: (response) => ({ response }),
    failure: ({ code, description, status }) => ({
      code,
      description,
      status,
    }),
  });
}

export const verifyPhoneNumber = createVerifyRoutine('VERIFY_PHONE_NUMBER');
export const verifyVerificationCode = createVerifyRoutine('VERIFY_VERIFICATION_CODE');
export const verifyLicenceNumber = createVerifyRoutine('VERIFY_LICENCE_NUMBER');
export const verifyEmail = createVerifyRoutine('VERIFY_EMAIL');
export const login = createRoutine('LOGIN', {
  request: (response) => ({ response }),
});

export const setUser = createAction('SET_USER', (user) => ({ payload: { user } }));
export const logout = createAction('LOGOUT');
export const backToStep = createAction('BACK_TO_STEP');
export const setStep = createAction('SET_STEP', (step: VerificationStep) => ({
  payload: { step },
}));

export const getLyftHeaders = createRoutine('GET_LYFT_HEADERS', {
  success: ({
    accessTokenLicense,
    accessTokenParams,
    accessTokenPhone,
    accountIdentifiers,
    phoneAuth,
    tcsConfig,
  }) => ({
    accessTokenLicense,
    accessTokenParams,
    accessTokenPhone,
    accountIdentifiers,
    phoneAuth,
    tcsConfig,
  }),
});

export const getLyftAuthAccessToken = createRoutine('GET_LYFT_AUTH_ACCESS_TOKEN', {
  fulfill: (response) => ({ response }),
  success: ({ token_type, access_token }) => ({ token_type, access_token }),
});

export const sendTcsConfig = createRoutine('SEND_TCS_CONFIG');

export const actionCreators = {
  setUser,
  logout,
  verifyPhoneNumber,
  verifyVerificationCode,
  verifyLicenceNumber,
  verifyEmail,
  backToStep,
  setStep,
  getLyftHeaders,
  getLyftAuthAccessToken,
  sendTcsConfig,
  login,
} as const;
